{
    "name": "@reflow/kit",
    "version": "0.2.6",
    "description": "",
    "main": "dist/reflow.kit.min.js",
    "unpkg": "dist/reflow.kit.min.js",
    "jsdelivr": "dist/reflow.kit.min.js",
    "scripts": {
        "build": "node esbuild.config.js",
        "dev": "esbuild src/app.ts --bundle --outfile=dist/app.js --watch --sourcemap",
        "release": "node publish.js"
    },
    "keywords": [],
    "author": "",
    "license": "ISC",
    "type": "module",
    "packageManager": "pnpm@10.12.1",
    "devDependencies": {
        "@types/jquery": "^3.5.33",
        "esbuild": "^0.25.9",
        "typescript": "^5.9.2"
    },
    "dependencies": {
        "lenis": "^1.3.11"
    }
}
